/**
 * 采购执行
 * */
// 采购合同
import contractQuery from '@/page/contract/contract-query';
//合同明细查询
import contractDetailQuery from '@/page/contract/contract-detail-query';
import contractView from '@/page/contract/contract-view';
// 采购申请
import purRequisitionList from '@/page/purchase-requisition/pur-requisition-list';
import purRequisitionTodoList from '@/page/purchase-requisition/pur-requisition-todo-list';
import purRequisitionDemand from '@/page/purchase-requisition/pur-requisition-demand';
// 采购订单
import purchaseOrderConfirm from '@/page/purchase-order/purchase-order-confirm';
import purchaseOrderView from '@/page/purchase-order/purchase-order-view';
import orderApprove from '@/page/purchase-order/order-approve';
import approvalAgency from '@/page/purchase-order/approval-agency';
// 客户要货计划
import cargoQueryPlan from '@/page/cargo-plan/cargo-query-plan';
import cargoQueryPlanTodo from '@/page/cargo-plan/cargo-query-plan-todo';
import cargoPendingDisposal from '@/page/cargo-plan/cargo-pending-disposal';
import cargoQueryRows from '@/page/cargo-plan/cargo-query-rows';
import cargoEdit from '@/page/cargo-plan/cargo-edit';
import cargoView from '@/page/cargo-plan/view/view';
import cargoBaseInfo from '@/page/cargo-plan/view/base-info';
import cargoPlanInfo from '@/page/cargo-plan/view/plan-info';
// 收货管理
import listReceived from '@/page/asn/list-received';
import receivedManagementView from '@/page/asn/received-management-view';
import receivedQueryList from '@/page/asn/received-query-list';
import receivedView from '@/page/asn/received-view/view';
// 送货管理
import asnList from '@/page/asn/asn-list';
import asnNeedList from '@/page/asn/asn-need-list';
import asnTodoList from '@/page/asn/asn-todo-list';
import asnView from '@/page/asn/view/view';
import asnEdit from '@/page/asn/view/edit';
import asnCreat from '@/page/asn/view/creat';

//质量管理
import qualityManagementList from '@/page/quality-management/quality-management-list';
import qualityManagementView from '@/page/quality-management/quality-management-view';
//索赔管理
import claimManagementList from '@/page/claim-management/claim-management-list';
//对账单
import soaList from '@/page/soa/soa-list';
//采购协同
import consignment from '@/page/procu-syner/consignment';
import outsourcing from '@/page/procu-syner/outsourcing';
//模具管理
import moduleList from '@/page/procu-syner/module-list';
import moduleDetail from '@/page/procu-syner/module-detail';
//产出管理
import outputList from '@/page/procu-syner/output-list';
import outputDetail from '@/page/procu-syner/output-detail';
//库存管理
import inventoryList from '@/page/procu-syner/inventory-list';
import inventoryDetail from '@/page/procu-syner/inventory-detail';
//付款查询
import paymentList from '@/page/procu-syner/payment-list';
import paymentDetail from '@/page/procu-syner/payment-detail';
import predictList from '@/page/procu-syner/predict-list';
export default [
  /**
   * 采购执行
   * */
  {
    path: '/pur-requisition-list',
    component: purRequisitionList,
    meta: {
      title: '采购申请列表'
    }
  },
  {
    path: '/pur-requisition-todo-list',
    component: purRequisitionTodoList,
    meta: {
      title: '我的待办'
    }
  },
  {
    path: '/pur-requisition-demand',
    component: purRequisitionDemand,
    meta: {
      title: '需求池'
    }
  },
  {
    path: '/purchase-order-confirm',
    component: purchaseOrderConfirm,
    meta: {
      title: '待确认订单'
    }
  },
  {
    path: '/purchase-order-view/:id',
    component: purchaseOrderView,
    meta: {
      title: '采购订单'
    }
  },
  {
    path: '/order-approve',
    component: orderApprove,
    meta: {
      title: '采购订单'
    }
  },
  {
    path: '/approval-agency',
    component: approvalAgency,
    meta: {
      title: '采购订单待办'
    }
  },
  {
    path: '/cargo-query-plan',
    component: cargoQueryPlan,
    meta: {
      title: '查询要货计划单'
    }
  },
  {
    path: '/cargo-query-plan-todo',
    component: cargoQueryPlanTodo,
    meta: {
      title: '查询要货计划单代办'
    }
  },
  {
    path: '/cargo/view/:id',
    component: cargoView,
    children: [
      {
        path: '/',
        redirect: 'base-info'
      },
      {
        path: 'base-info',
        component: cargoBaseInfo,
        mate: {
          name: "基本信息"
        }
      },
      {
        path: 'plan-info',
        component: cargoPlanInfo,
        mate: {
          name: "计划明细"
        }
      }
    ],
    meta: {
      title: '要货计划详情'
    }
  },
  {
    path: '/cargo-pending-disposal',
    component: cargoPendingDisposal,
    meta: {
      title: '确认要货计划单'
    }
  },
  {
    path: '/cargo-query-rows',
    component: cargoQueryRows,
    meta: {
      title: '查询计划行'
    }
  },
  {
    path: '/cargo-edit/:id',
    component: cargoEdit,
    meta: {
      title: '要货计划-编辑'
    }
  },
  {
    path: '/cargo-view/:id',
    component: cargoView,
    meta: {
      title: '要货计划-查看'
    }
  },
  {
    path: '/list-received',
    component: listReceived,
    meta: {
      title: '到货看板'
    }
  },
  {
    path: '/asn/view/:id',
    component: asnView,
    meta: {
      title: '送货管理详情'
    }
  },
  {
    path: '/asn/edit/:id',
    component: asnEdit,
    meta: {
      title: '送货管理编辑'
    }
  },
  {
    path: '/asn/creat/:id',
    component: asnCreat,
    meta: {
      title: '送货单创建'
    }
  },

  // {
  //   path: '/asn-view/:id',
  //   component: asnView,
  //   meta: {
  //     title: '到货看板'
  //   }
  // },
  {
    path: '/received-query-list',
    component: receivedQueryList,
    meta: {
      title: '收货查询'
    }
  },
  {
    path: '/received/view/:id',
    component: receivedView
  },
  {
    path: '/received-management-view/:id',
    component: receivedManagementView,
    meta: {
      title: '入库单-查看'
    }
  },
  {
    path: '/asn-list',
    component: asnList,
    meta: {
      title: '查询送货单'
    }
  },
  {
    path: '/asn-need-list',
    component: asnNeedList,
    meta: {
      title: '创建送货单'
    }
  },
  {
    path: '/asn-todo-list',
    component: asnTodoList,
    meta: {
      title: '待处理的送货单'
    }
  },
  {
    path: '/contract-query',
    component: contractQuery,
    meta:{
      title:'采购合同管理'
    }
  },
  {
    path: '/contract-detail-query',
    component: contractDetailQuery,
    meta:{
      title:'合同明细查询'
    }
  },
  {
    path:'/contract/:id/:type',
    component:contractView,
    meta:{
      title:'合同详情'
    }
  },
  {
    path: '/quality-management-list',
    component: qualityManagementList,
    meta: {
      title: '质量管理'
    }
  },
  {
    path: '/quality-management-view/:id',
    component: qualityManagementView,
    meta: {
      title: '质量管理详情'
    }
  },
  {
    path: '/claim-management-list',
    component: claimManagementList,
    meta: {
      title: '索赔管理',
      keepalive:true
    }
  },
  {
    path: '/soa-list',
    component: soaList,
    meta: {
      title: '对账单'
    }
  },
  {
    path:'/consignment/:type',
    component:consignment,
    meta:{
      title:'寄售协同'
    }
  },
  {
    path:'/outsourcing/:type',
    component:outsourcing,
    meta:{
      title:'委外协同'
    }
  },
  {
    path:'/module-list',
    component:moduleList,
    meta:{
      name:'模具管理'
    }
  },
  {
    path:'/module-detail/:id',
    component:moduleDetail,
    meta:{
      name:'模具详情'
    }
  },
  {
    path:'/output-list',
    component:outputList,
    meta:{
      name:'产出反馈'
    }
  },
  {
    path:'/output-detail/:id',
    component:outputDetail,
    meta:{
      name:'产出详情'
    }
  },
  {
    path:'/inventory-list',
    component:inventoryList,
    meta:{
      name:'库存反馈'
    }
  },
  {
    path:'/inventory-detail/:id',
    component:inventoryDetail,
    meta:{
      name:'库存详情'
    }
  },
//  付款查询
  {
    path:'/payment-list',
    component:paymentList,
    meta:{
      name:'付款查询'
    }
  },
  {
    path:'/payment-detail/:id',
    component:paymentDetail,
    meta:{
      name:'付款详情'
    }
  },
  {
    path:'/predict-list',
    component:predictList,
    meta:{
      name:'预测协同'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/procure.js